import React from 'react';
import Conditional from '../../common/conditional';

import { PDFPageDetailsProps, Project } from '../../../utils/models';
import { concatClassNames, formatTime } from '../../../utils/utilities';
import { APP_DATE_FORMAT } from '../../../utils/constants';

import styles from './pdf.module.scss';

type Props = PDFPageDetailsProps & Project;

const PDFPageDetails: React.FC<Props> = ({
	createdAt,
	equipmentDescription,
	equipmentTag,
	location,
	pageSubtitle,
	pageTitle,
	projectTitle,
}) => {
	const classNames = concatClassNames([styles['page-details-grid'], 'col']);

	return (
		<div className={styles['page-details']}>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className={classNames}>
						<div>Equipment Tag No:</div>
						<div className={styles['page-details-value']}>{equipmentTag}</div>
					</div>

					<div className={classNames}>
						<div>{pageTitle}</div>
					</div>

					<div className={classNames}>
						<div className={styles['page-details-title']}>
							Equipment Description:
						</div>

						<div className={styles['page-details-value']}>
							{equipmentDescription}
						</div>
					</div>
				</div>

				<div className="row">
					<div className={classNames}>
						<div>Date: {formatTime(createdAt, APP_DATE_FORMAT)}</div>
					</div>

					<div className={classNames}>
						<div>{projectTitle}</div>
					</div>

					<div className={classNames}>
						<div>Location: {location}</div>
					</div>
				</div>
			</div>

			<Conditional isVisible={!!pageSubtitle}>
				<div
					className={concatClassNames([
						styles['page-details-grid'],
						styles['page-details-subtitle'],
					])}
				>
					<div>{pageSubtitle}</div>
				</div>
			</Conditional>
		</div>
	);
};

export default PDFPageDetails;
